import './App.css';
import { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Projects from './components/Projects';
import Services from './components/Services';
import Members from './components/Members';
import Contact from './components/Contact';
import Portfolio from './components/Portfolio';
import CV from './components/CV';
import SocialLinks from './components/SocialLinks';
import Seo from './components/Seo';

const CV_ROUTES = {
  '/equipo/mariano-paz': 'mariano',
  '/equipo/ignacio-naval-esparrell': 'nacho',
  '/equipo/francisco-emanuel-diaz-ortiz': 'manu',
  '/equipo/manu': 'manu',
  '/equipo/tomas-heredia': 'tomas'
};

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [showCV, setShowCV] = useState(() => CV_ROUTES[window.location.pathname] || null);

  useEffect(() => {
    const handlePopState = () => setShowCV(CV_ROUTES[window.location.pathname] || null);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const element = document.getElementById(activeSection);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [activeSection]);

  const handleShowCV = (member, path) => {
    window.history.pushState({}, '', path);
    setShowCV(member);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackFromCV = () => {
    window.history.pushState({}, '', '/');
    setShowCV(null);
    setActiveSection('members');
  };

  if (showCV) {
    return <><Seo member={showCV} /><CV member={showCV} onBack={handleBackFromCV} /></>;
  }

  return (
    <div className="site-shell min-h-screen text-white">
      <Seo member={null} />
      <Navigation activeSection={activeSection} setActiveSection={setActiveSection} />
      
      <main className="pt-14 sm:pt-16">
        <Hero setActiveSection={setActiveSection} />
        {activeSection === 'projects' && <Projects setActiveSection={setActiveSection} />}
        {activeSection === 'services' && <Services setActiveSection={setActiveSection} />}
        {activeSection === 'portfolio' && <Portfolio />}
        {activeSection === 'members' && <Members onShowCV={handleShowCV} />}
        {activeSection === 'contact' && <Contact />}
      </main>

      <SocialLinks />
    </div>
  );
}

export default App;
